import styled from 'styled-components';

export const ContainerBoxSelecao = styled.div`
  width: 200px;

  @media (max-width: 910px) {
    width: 100%;
  }
`;

export const BoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 910px) {
    flex-wrap: wrap;
  }
`;

export const FilterBox = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 755px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;
